import Splide from '@splidejs/splide';

const tallSettings = {
    perPage: 1,
    gap: 4,
    perMove: 1,
    pagination: false,
    mediaQuery: 'min',
    breakpoints: {
        768: {
            perPage: 2,
            gap: 4,
            padding: { right: '5%' },
        },
        1200: {
            perPage: 2,
            gap: 16,
            padding: { right: 0 },
        },
    },
}

const imageSettings = {
    perPage: 1,
    perMove: 1,
    gap: 8,
    pagination: false,
    mediaQuery: 'min',
    breakpoints: {
        1200: {
            gap: 64,
            padding: { right: '20%' },
        },
    },
}

const CardSlider = () => {
    const sections = document.querySelectorAll('.block-card-slider, .block-contacts-slider, .block-news-cards, .block-event-cards, .block-document-cards');

    for (const section of sections) {
        const basicElement = section.querySelector(':scope.card-slider-basic .splide');
        const isOnProjectPage = section.closest('.project-template-wrapper') !== null;
        if (basicElement) {
            new Splide( basicElement, {
                perPage: 1,
                gap: 4,
                pagination: false,
                perMove: 1,
                mediaQuery: 'min',
                breakpoints: {
                    768: {
                        perPage: 2,
                        padding: { right: '5%' },
                    },
                    1200: {
                        perPage: isOnProjectPage ? 2 : 3,
                        gap: 16,
                        padding: { right: 0 },
                    },
                },
            } ).mount( {} );
        }

        const tallElement = section.querySelector(':scope.card-slider-tall .splide');
        if (tallElement) {
            const splide = new Splide( tallElement, tallSettings ).mount( {} );
            splide.on('move', (newIndex, oldIndex, destIndex) => {
                const slides = splide.Components.Slides.get();
              
                slides.forEach((Slide, i) => {
                    const el = Slide.slide;
                    el.style.transition = 'transform 0.6s ease, opacity .5s';
                    if (i < newIndex) {
                        el.style.transform = `opacity .3s`;

                        if (window.innerWidth < 1200) {
                            el.style.opacity = 1;
                        } else {
                            el.style.opacity = 0;
                        }
                    } else {
                        el.style.opacity = 1;
                    }
                });
            });
        }

        const imageContentElement = section.querySelector(':scope.card-slider-image .splide-content');
        const imageImagesElement = section.querySelector(':scope.card-slider-image .splide-images');
        if (imageContentElement && imageImagesElement) {
            const contentSplide = new Splide( imageContentElement, imageSettings ).mount( {} );
            const imagesSplide = new Splide( imageImagesElement, {
                perPage: 1,
                perMove: 1,
                gap: 0,
                pagination: false,  
                arrows: false,
                type: 'fade',
            } ).mount( {} );

            contentSplide.sync( imagesSplide );
        }

        const contactsElement = section.querySelector(':scope.card-slider-contacts .splide');
        if (contactsElement) {
            new Splide( contactsElement, {
                perPage: 1,
                gap: 16,
                pagination: false,
                perMove: 1,
                mediaQuery: 'min',
                breakpoints: {
                    768: {
                        perPage: 1,
                        gap: 16,
                        padding: { right: '40%' },
                    },
                    992: {
                        perPage: 2,
                        gap: 16,
                        padding: { right: '5%' },
                    },
                    1200: {
                        perPage: 2,
                        gap: 24,
                        padding: { right: '20%' },
                    },
                    1400: {
                        perPage: 3,
                        gap: 24,
                        padding: { right: 0 },
                    },
                },
            } ).mount( {} );
        }
    }
}

export default CardSlider;